window.env = process.env;

console.log('browser.js is loaded');
